export default __webpack_public_path__ + "static/media/logo.dce0d036.png";